import version from './version';
import { ENV, getEnvByOrigin } from '../services/environment.service';
import { API_PORT_FOR_E2E } from '../../generated/e2eCFG';

const origin = process.env.REACT_APP_E2E_TEST ? `http://localhost:${API_PORT_FOR_E2E}` : window.location.origin;
const defaultValues = {
    cdn: 'https://cdn.walkme.com',
    version,
    debugMode: false,
    enableDynamicAttributes: false,
    host: window.location.origin,
    baseWalkmeApiUrl: 'https://api.walkme.com',
    // Make sure to override this value in all envs
    apiUrl: `${origin}/api`,
    // Make sure to override this value in all envs
    graphQlUrl: `${origin}/graphql`,
    osUrl: 'https://api.walkme.com/walkme-os-api/graphql',
    accountsDomainUrl: 'https://api.walkme.com',
    authClientId: '0oa12nlligZwRh46a5d7',
    authUrl: 'https://auth.walkme.com/oauth2/default',
    shellSdkAppName: 'comcenter',
    datadogConfig: {
        adminRUMApplicationId: '8f7c228e-0af9-461b-be28-d67698c92549',
        adminClientToken: 'pub66896a98465223084322b95c458db281',
        adminServiceName: 'communication-center-admin',
        datadogSite: 'datadoghq.com',
        RUMProxyDomain: 'logs.walkme.com',
        useDataDogLogger: false,
        useDataDogRUM: true
    },
    eventCollectorUrl: 'https://ec.walkme.com',
    useECService: true,
    consoleRootUrl: 'https://console.walkme.com/',
    w5gUrl: 'https://web-client.apps.walkme.com/w5g/index.html',
    basicFetchTimeout: 31000, // has to be bigger then axios timeout error on server in order to get timeout errors from server
    recipientsListReportTimeout: 51000, // has to be bigger then axios timeout error on server in order to get timeout errors from server
    analyticsFetchTimeout: 15000,
    analyticsRetry: {
        interval: 3000,
        count: 3
    },
    analyticsPollingIntervals: {
        summary: 120000,
        details: 120000
    },
    adminUsersAndRoles: 'https://admin.walkme.com/users/manage',
    learnMoreApiNotifications: {
        en: 'https://support.walkme.com/knowledge-base/workstation-notifications-api/',
        ja: 'https://support.walkme.com/ja/knowledge-base/workstation通知api/'
    },
    learnMoreAnalyticsSource: {
        en: 'https://support.walkme.com/knowledge-base/walkme-communication-center/#communication-insights',
        ja:
            'https://support.walkme.com/ja/knowledge-base/walkme-communication-center（コミュニケーションセンター）/#e382b3e3839fe383a5e3838be382b1e383bce382b7e383a7e383b3e382a4e383b3e382b5e382a4e38388'
    },
    manageIntegrationsHost: 'https://insights2.walkme.com',

    getENV: () => {
        return getEnvByOrigin(window.location.origin) || ENV.DEV;
    }
};

const getENV = defaultValues.getENV;

const ENVIRONMENT = {
    [ENV.DEV]: {
        ...defaultValues,
        debugMode: true,
        shellSdkAppName: 'dev-app',
        useECService: false,
        eventCollectorUrl: 'https://ec.walkmedev.com',
        datadogConfig: {
            ...defaultValues.datadogConfig,
            useDataDogRUM: false,
            useDataDogLogger: false,
            RUMProxyDomain: 'logs.walkmedev.com'
        },
        w5gUrl: 'https://web-client.apps.walkme.com/w5g/index.html'
    },
    [ENV.EU_DEV]: {
        ...defaultValues,
        baseWalkmeApiUrl: 'https://eu-api.walkme.com',
        debugMode: true,
        shellSdkAppName: 'dev-app',
        osUrl: 'https://eu-api.walkme.com/walkme-os-api/graphql',
        accountsDomainUrl: 'https://eu-api.walkme.com',
        useECService: false,
        eventCollectorUrl: 'https://ec.walkmedev.com',
        datadogConfig: {
            ...defaultValues.datadogConfig,
            useDataDogRUM: false,
            useDataDogLogger: false,
            datadogSite: 'datadoghq.eu',
            RUMProxyDomain: 'logs.walkmedev.com'
        },
        consoleRootUrl: 'https://eu-console.walkme.com/',
        w5gUrl: 'https://eu-web-client.apps.walkmeqa.com/w5g/index.html'
    },
    /*
    dev2: {
        ...defaultValues,
        debugMode: true,
        osUrl: 'https://api2.walkmedev.com/walkme-os-api/graphql',
        accountsDomainUrl: 'https://api2.walkmedev.com',
        eventCollectorUrl: 'https://ec2.walkmedev.com',
        datadogConfig: {
            ...defaultValues.datadogConfig,
            RUMProxyDomain: 'logs.walkmedev.com'
        },
        w5gUrl: 'https://w5g.walkmedev.com/'
    },*/
    [ENV.QA_DEV]: {
        ...defaultValues,
        cdn: 'https://cdn.walkmeqa.com',
        baseWalkmeApiUrl: 'https://api.walkmeqa.com',
        debugMode: true,
        shellSdkAppName: 'dev-app',
        osUrl: 'https://api.walkmeqa.com/walkme-os-api/graphql',
        accountsDomainUrl: 'https://api.walkmeqa.com',
        useECService: false,
        eventCollectorUrl: 'https://ec.walkmedev.com',
        datadogConfig: {
            ...defaultValues.datadogConfig,
            useDataDogRUM: false,
            useDataDogLogger: false,
            RUMProxyDomain: 'logs.walkmeqa.com'
        },
        authUrl: 'https://auth.walkmeqa.com/oauth2/default',
        authClientId: '0oa12nmduwoQAX1Uu5d7',
        consoleRootUrl: 'https://console.walkmeqa.com/',
        w5gUrl: 'https://web-client.apps.walkmeqa.com/w5g/index.html'
    },
    [ENV.QA]: {
        ...defaultValues,
        cdn: 'https://cdn.walkmeqa.com',
        baseWalkmeApiUrl: 'https://api.walkmeqa.com',
        apiUrl: 'https://api.walkmeqa.com/communication-center/api',
        graphQlUrl: 'https://api.walkmeqa.com/communication-center/graphql',
        osUrl: 'https://api.walkmeqa.com/walkme-os-api/graphql',
        accountsDomainUrl: 'https://api.walkmeqa.com',
        eventCollectorUrl: 'https://ec.walkmeqa.com',
        datadogConfig: {
            ...defaultValues.datadogConfig,
            RUMProxyDomain: 'logs.walkmeqa.com'
        },
        consoleRootUrl: 'https://console.walkmeqa.com/',
        w5gUrl: 'https://web-client.apps.walkmeqa.com/w5g/index.html',
        authUrl: 'https://auth.walkmeqa.com/oauth2/default',
        authClientId: '0oa12nmduwoQAX1Uu5d7',
        adminUsersAndRoles: 'https://admin.walkmeqa.com/users/manage',
        manageIntegrationsHost: 'https://insights2.walkmeqa.com'
    },
    [ENV.EU_PROD]: {
        ...defaultValues,
        baseWalkmeApiUrl: 'https://eu-api.walkme.com',
        apiUrl: 'https://eu-api.walkme.com/communication-center/api',
        graphQlUrl: 'https://eu-api.walkme.com/communication-center/graphql',
        osUrl: 'https://eu-api.walkme.com/walkme-os-api/graphql',
        accountsDomainUrl: 'https://eu-api.walkme.com',
        eventCollectorUrl: 'https://eu-ec.walkme.com',
        datadogConfig: {
            ...defaultValues.datadogConfig,
            adminRUMApplicationId: 'acfbce8b-ef3d-483d-9caf-72ca6855d7b2',
            adminClientToken: 'pub421aaefb566ea4fa84e2677886b7fe17',
            datadogSite: 'datadoghq.eu',
            RUMProxyDomain: 'eu-logs.walkme.com'
        },
        consoleRootUrl: 'https://eu-console.walkme.com/',
        w5gUrl: 'https://eu-web-client.apps.walkme.com/w5g/index.html',
        cdn: 'https://eu-cdn.walkme.com',
        authUrl: 'https://eu-auth.walkme.com/oauth2/default',
        authClientId: '0oaw1bwz3VCtohTd8416',
        adminUsersAndRoles: 'https://eu-admin.walkme.com/users/manage',
        manageIntegrationsHost: 'https://eu-insights2.walkme.com'
    },
    [ENV.PROD]: {
        ...defaultValues,
        apiUrl: 'https://api.walkme.com/communication-center/api',
        graphQlUrl: 'https://api.walkme.com/communication-center/graphql',
        authUrl: 'https://auth.walkme.com/oauth2/default',
        authClientId: '0oa12nlligZwRh46a5d7',
        adminUsersAndRoles: 'https://admin.walkme.com/users/manage'
    },
    [ENV.STAGING]: {
        ...defaultValues,
        apiUrl: 'https://api.walkme.com/communication-center-staging/api',
        graphQlUrl: 'https://api.walkme.com/communication-center-staging/graphql',
        osUrl: 'https://api.walkme.com/walkme-os-api/graphql',
        accountsDomainUrl: 'https://api.walkme.com',
        cdn: 'https://cdn-staging.apps.walkme.com',
        authUrl: 'https://auth.walkme.com/oauth2/default',
        authClientId: '0oa12nlligZwRh46a5d7',
        adminUsersAndRoles: 'https://admin.walkme.com/users/manage'
    }
};

export default (ENVIRONMENT[getENV()] || defaultValues) as typeof defaultValues;
